export default function() {
  (function($) {
    $(function() {
      [...document.querySelectorAll("a")].map(item => {
        let addExternalAttrs = false;

        if (item.hostname && item.hostname === location.hostname) {
          if (item.pathname.indexOf(".pdf") > -1) {
            addExternalAttrs = true;
          }
        } else if (item.hostname && item.hostname.indexOf("netforum") === -1) {
          addExternalAttrs = true;
        }

        if (addExternalAttrs) {
          item.target = "_blank";
          item.rel = "noopener noreferrer";
        }
      });

      $(".js-content").removeClass("hidden");

      $('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').wrap(
        '<div class="video-embed" />'
      );

      /**
       * Back to top
       */
      const $backToTop = $(".mg-back-to-top");

      $backToTop.on("click", e => {
        e.preventDefault();
        $("html, body").animate({ scrollTop: 0 });
      });

      $(window).on("scroll", function() {
        const scrollFromTop = $(this).scrollTop();
        if (scrollFromTop > this.innerHeight) {
          $backToTop.removeClass("hidden");
        } else {
          $backToTop.addClass("hidden");
        }
      });

      // $('iframe[src*="youtube.com"]').each(function() {
      //     let src = $(this).attr("src");
      //     let newSrc = src.indexOf("?") > -1 ? src + "&rel=0" : "?rel=0";
      //     $(this).attr("src", newSrc);
      // });
    });
  })(jQuery);
}



// WEBPACK FOOTER //
// ./src/js/partials/content.js